import request from '@/utils/request'


// 查询折扣活动配置列表
export function listDiscount(query) {
  return request({
    url: '/discount/discount/list',
    method: 'get',
    params: query
  })
}
export function auditDiscountActivityProd(data) {
  return request({
    url: '/discount/discount/audit',
    method: 'post',
    data: data
  })
}
// 查询折扣活动配置分页
export function pageDiscount(query) {
  return request({
    url: '/discount/discount/page',
    method: 'get',
    params: query
  })
}

// 查询折扣活动配置详细
export function getDiscount(data) {
  return request({
    url: '/discount/discount/detail',
    method: 'get',
    params: data
  })
}

// 新增折扣活动配置
export function addDiscount(data) {
  return request({
    url: '/discount/discount/add',
    method: 'post',
    data: data
  })
}

// 修改折扣活动配置
export function updateDiscount(data) {
  return request({
    url: '/discount/discount/edit',
    method: 'post',
    data: data
  })
}

// 删除折扣活动配置
export function delDiscount(data) {
  return request({
    url: '/discount/discount/delete',
    method: 'post',
    data: data
  })
}
